import type { Theme } from '@mui/material';

export const styles = {
  dropzone: (highlight: boolean) => (theme: Theme) => ({
    flexGrow: 1,
    minHeight: '17.5rem',
    marginBottom: 0,
    alignItems: 'center',
    height: 'auto',
    padding: '4px 8px',
    backgroundColor: theme.colors.white,
    border: `2px solid ${theme.colors.neutral[300]}`,
    borderRadius: '0.25rem',
    borderColor: highlight
      ? theme.colors.primary[500]
      : theme.colors.neutral[300],
  }),

  decoration: {
    margin: 'auto',
    minHeight: '5.625rem',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  hint: (theme: Theme) => ({
    color: theme.colors.neutral[400],
    fontSize: 13,
  }),

  fileChooser: {
    display: 'none',
  },
};
